import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const Wrapper = styled.div`
  border: 0.5px solid ${select('neutralDarkGray')};
  border-radius: 8px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: ${({ device }) => (device === 'mobile' ? '100%' : 'auto')};
  min-width: 320px;
`;

const Title = styled.p`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
  white-space: break-spaces;
`;

const Subtitle = styled.p`
  font-size: ${({ device }) => (device === 'mobile' ? '14px' : '16px')};
  margin-bottom: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  white-space: break-spaces;
`;

const ContactName = styled.p`
  font-weight: 600;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 8px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-bottom: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

const IconWrapper = styled.div`
  margin-right: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  width: ${({ isPeru, isBrazil }) => {
    if (isPeru || isBrazil) return '284px';
    return '242px';
  }};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  white-space: break-spaces;
  @media (max-width: 431px) {
    width: 90%;
  }

  @media (max-width: 361px) {
    width: 80%;
  }
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  color: ${select('black')};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  height: 24px;
  padding: 0px 12px;

  &:hover {
    border-radius: 8px;
    background: ${select('neutralDarkGray')};
  }
`;
const WhatsAppLink = styled.a`
  text-decoration: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: ${select('black')};
  :hover {
    text-decoration: ${({ device }) => (device === 'desktop' ? 'underline' : 'underline')};
  }
`;

const ECommerceButton = styled.a`
  display: flex;
  height: 32px;
  padding: 0 12px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background-color: ${select('primaryBlue')};
  color: ${select('black')};
  text-decoration: none;
  text-align: center;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  margin-top: 16px;
  width: fit-content;
  transition: background-color 0.2s ease;
  :hover {
    height: 32px;
    padding: 0 12px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 8px;
    background: ${select('neutralDarkGray')};
  }
`;

export { Wrapper, Title, Subtitle, ContactName, Row, IconWrapper, CopyButton, WhatsAppLink, ECommerceButton };
